import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './styles.scss'

const ContentHolder = (props) => {
  const {
    children, className, contentWidthId, row, fullWidth, style,
  } = props

  return (
    <div
      className={classnames(
        className,
        styles.root,
        row ? styles.row : null,
        fullWidth ? styles.fullWidth : null,
        contentWidthId ? styles[contentWidthId] : null,
      )}
      style={style}
    >
      {children}
    </div>
  )
}

ContentHolder.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  contentWidthId: PropTypes.string,
  fullWidth: PropTypes.bool,
  row: PropTypes.bool,
  style: PropTypes.object,
}

export default ContentHolder
